<template>
  <CRow class="dashboard-kpis">
    <CCol v-for="card in cards" :key="card.key" sm="6" lg="4" xl="2" class="mb-3">
      <div class="kpi-card" :class="`kpi-card--${card.key}`">
        <div class="kpi-card__icon">
          <CIcon :name="card.icon" />
        </div>
        <div class="kpi-card__body">
          <div class="kpi-card__value" :class="{ 'kpi-card__value--small': card.smallValue }">{{ card.value }}</div>
          <div class="kpi-card__label">{{ card.label }}</div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import eventStatsService from '@/services/dashboard/event_stats_dashboard'

export default {
  name: 'EventStatsCards',
  props: {
    eventId: { type: [String, Number], required: true },
    refreshToken: { type: Number, default: 0 }
  },
  data() {
    return {
      stats: {
        totalGuests: 0,
        confirmed: 0,
        pending: 0,
        declined: 0,
        withoutTable: 0,
        nextScheduledDisplay: 'Sin envios programados'
      }
    }
  },
  computed: {
    cards() {
      const noSchedule = !this.stats.nextScheduledDisplay || this.stats.nextScheduledDisplay === 'Sin envios programados'

      return [
        { key: 'total', icon: 'cil-people', value: this.stats.totalGuests, label: 'Total de invitados' },
        { key: 'confirmed', icon: 'cil-check-circle', value: this.stats.confirmed, label: 'Confirmados' },
        { key: 'pending', icon: 'cil-clock', value: this.stats.pending, label: 'Pendientes' },
        { key: 'declined', icon: 'cil-x-circle', value: this.stats.declined, label: 'No asistiran' },
        { key: 'without-table', icon: 'cil-layers', value: this.stats.withoutTable, label: 'Sin mesa' },
        {
          key: 'next-send',
          icon: 'cil-calendar',
          value: this.stats.nextScheduledDisplay || 'Sin envios programados',
          label: 'Proximo envio programado',
          smallValue: noSchedule || (this.stats.nextScheduledDisplay || '').length > 16
        }
      ]
    }
  },
  watch: {
    eventId: {
      immediate: true,
      handler() {
        this.loadStats()
      }
    },
    refreshToken() {
      this.loadStats()
    }
  },
  methods: {
    async loadStats() {
      this.stats = await eventStatsService.get(this.eventId)
    }
  }
}
</script>

<style scoped>
.kpi-card {
  display: flex;
  align-items: center;
  min-height: 94px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #dde6dd;
  background: linear-gradient(180deg, #ffffff 0%, #f7faf7 100%);
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.08);
}

.kpi-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 17px;
  color: #fff;
}

.kpi-card__body {
  min-width: 0;
}

.kpi-card__value {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.1;
  overflow-wrap: anywhere;
}

.kpi-card__value--small {
  font-size: 12px;
  line-height: 1.3;
}

.kpi-card__label {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.kpi-card--total .kpi-card__icon {
  background: #637084;
}

.kpi-card--confirmed .kpi-card__icon {
  background: #4a8f5e;
}

.kpi-card--pending .kpi-card__icon {
  background: #c4a948;
}

.kpi-card--declined .kpi-card__icon {
  background: #b85b5b;
}

.kpi-card--without-table .kpi-card__icon {
  background: #668269;
}

.kpi-card--next-send .kpi-card__icon {
  background: #516775;
}
</style>
